package com.rainbowclubs.rainbow.presentation.messages

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import com.rainbowclubs.rainbow.data.models.MembershipStatus
import com.rainbowclubs.rainbow.presentation.ScreenState
import com.rainbowclubs.rainbow.presentation.common.ErrorScreen
import com.rainbowclubs.rainbow.presentation.common.LoadingScreen
import com.rainbowclubs.rainbow.presentation.common.MembershipStatusCard
import com.rainbowclubs.rainbow.presentation.common.bottomNavBar.BottomNavBar
import com.rainbowclubs.rainbow.presentation.common.bottomNavBar.BottomNavItem
import com.rainbowclubs.rainbow.presentation.theme.transparent
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.viewmodel.koinViewModel
import org.koin.core.parameter.parametersOf
import rainbowclubs.composeapp.generated.resources.*

@Composable
fun MessagesScreen(
    clubId: String,
    viewModel: MessagesViewModel = koinViewModel(parameters = { parametersOf(clubId) }),
    onNavigateToHome: (String) -> Unit,
    onNavigateToClub: (String) -> Unit,
    onNavigateToMore: (String) -> Unit,
) {
    val screenState by viewModel.screenState.collectAsState()

    Scaffold(
        containerColor = MaterialTheme.colorScheme.transparent,
        bottomBar = {
            BottomNavBar(
                selectedItem = BottomNavItem.Messages,
                onHomeClick = { onNavigateToHome(clubId) },
                onClubClick = { onNavigateToClub(clubId) },
                onMessagesClick = { },
                onMoreClick = { onNavigateToMore(clubId) },
            )
        },
    ) { paddingValues ->
        Box(
            modifier = Modifier
                .padding(paddingValues)
                .fillMaxSize(),
            contentAlignment = Alignment.Center,
        ) {
            when (val state = screenState) {
                is ScreenState.Loading -> LoadingScreen(Modifier.fillMaxSize())
                is ScreenState.Error -> ErrorScreen(
                    error = stringResource(Res.string.general_error),
                    onButtonClick = viewModel::fetchMembershipStatus,
                    buttonText = stringResource(Res.string.try_again_button),
                )

                is ScreenState.Content -> {
                    if (state.data == MembershipStatus.APPROVED) {
                        MessagesNotSupportedCard()
                    } else {
                        MembershipStatusCard(status = state.data)
                    }
                }
            }
        }
    }
}

@Composable
private fun MessagesNotSupportedCard() {
    Card(
        modifier = Modifier
            .fillMaxWidth()
            .padding(16.dp),
        shape = RoundedCornerShape(16.dp),
        colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surface),
        border = BorderStroke(1.dp, MaterialTheme.colorScheme.outlineVariant)
    ) {
        Column(
            modifier = Modifier
                .padding(24.dp)
                .fillMaxWidth(),
            horizontalAlignment = Alignment.CenterHorizontally,
        ) {
            Icon(
                painter = painterResource(Res.drawable.ic_warning),
                contentDescription = null,
                modifier = Modifier.size(48.dp),
                tint = MaterialTheme.colorScheme.primary,
            )

            Spacer(modifier = Modifier.height(16.dp))

            Text(
                text = stringResource(Res.string.messages_not_supported_title),
                style = MaterialTheme.typography.headlineSmall,
                fontWeight = FontWeight.Bold,
                color = MaterialTheme.colorScheme.onSurface,
            )

            Spacer(modifier = Modifier.height(8.dp))

            Text(
                text = stringResource(Res.string.messages_not_supported_description),
                style = MaterialTheme.typography.bodyMedium,
                color = MaterialTheme.colorScheme.outline,
                textAlign = TextAlign.Center,
            )
        }
    }
}
